module.exports = __webpack_public_path__ + "img/twitter.f83a958c.svg";